import { v4 as uuid } from "uuid";
import { ref } from "vue";

export function useId() {
  const id = ref<string>(uuid());
  return id;
}
